import React from 'react';

import LiftIcon from '../../assets/lifts.svg';
import SlopeIcon from '../../assets/slope.svg';

import styles from './lifts.module.scss';

const LiftsInfo = ({ liftsInfo }) => (
  <div className={styles.wrapper}>
    <div className={liftsInfo.open ? styles.dot : styles.dotRed} />
    <p className={styles.paragraph}>{liftsInfo.open ? 'Otwarte' : 'Zamknięte'}</p>
    <p className={styles.paragraph}>
      <img className={styles.icon} src={LiftIcon} alt="Icon" />
      {liftsInfo.openLifts} / {liftsInfo.totalLifts}
    </p>
    <p className={styles.paragraph}>
      <img className={styles.icon} src={SlopeIcon} alt="Icon" />
      {liftsInfo.openRuns} / {liftsInfo.totalRuns}
    </p>
  </div>
);

export default LiftsInfo;
